import techfiThumbnail from "../Assets/Images/techfi_instagram.jpeg";
import chocosolTradersImage from "../Assets/Images/chocosol_traders_thumbnail.jpg";
import torontoIndieAuthorConImage from "../Assets/Images/toronto_indie_author_con.jpeg";
import agileCoursesThumbnail from "../Assets/Images/agile_thumbnail.png";
import beyondLawThumbnail from "../Assets/Images/beyondlaw_thumbnail.png";
import entreBookThumbnail from "../Assets/Images/entre_thumbnail.png";
import remolinoConsumerThumbnail from "../Assets/Images/remolino_consumer_thumbnail.png";
import remolinoBankruptcyThumbnail from "../Assets/Images/remolino_bank_thumbnail.png";
import seaOfButterfliesThumbnail from "../Assets/Images/seaofbutterflies_thumbnail.png";
import sreThumbnail from "../Assets/Images/sre_thumbnail.png";
import profileImage from "../Assets/Images/profile-image.jpeg";
import communicationImage from "../Assets/Images/case-studies/chocosol-brigadeiro-graded.jpg";
import marketingImage from "../Assets/Images/case-studies/marketing-queen-graded.jpg";
import articlesImage from "../Assets/Images/case-studies/articles-book-page-graded.jpg";
import coursesImage from "../Assets/Images/case-studies/course-building-graded.jpg";

const personalData = {
  name: "Bruna Porto",
  title: "Author, storyteller, and content writer",
  websiteTitle: "Bruna Porto",
  email: "brunaprto@gmail.com",
  location: "Toronto",

  socials: {
    instagram: "https://www.instagram.com/bruporto_/",
    tiktok: "https://www.tiktok.com/@bruporto_",
    youtube: "https://www.youtube.com/@porbrunaa",
    linkedin: "https://www.linkedin.com/in/bruporto/",
  },

  site: {
    title: "Bruna Porto",
    subtitle: "author & communications professional",
    blogUrl: "https://bruporto.substack.com",
    navigation: [
      { label: "home.", path: "/" },
    ],
  },

  home: {
    eyebrow: "welcome.",
    sideLabel: "about",
    bio:
      "Bruna Porto was born in the northeast of Brazil, and showed an interest in writing from a young age, publishing her first indie novel at the age of 13. With a Journalism degree and professional experience in marketing and communications, Bruna has published her first novel in the English language in February 2024. She now resides in Southern Ontario, and is currently working on her third novel.",
    portrait: {
      src: profileImage,
      alt: "Portrait of Bruna Porto",
    },
    book: {
      title: "Sea of Butterflies",
      cover: seaOfButterfliesThumbnail,
      synopsis: "A historical novel set during World War II that follows Ayana (\"Hanako\"), a famous geisha in Kyoto, who leaves the safety of the Hirata house after receiving a letter hinting at wartime atrocities in Manchuria, uncovering a network of comfort camps.",
      url: "https://www.amazon.ca/Sea-Butterflies-Bruna-Porto/dp/1804391786/",
    },
  },

  contactForm: {
    formspreeEndpoint: "https://formsubmit.co/bruna@brunaporto.com",
    title: "Get in Touch",
  },

  theme: {
    colors: {
      background: "#F9F6EE",
      surface: "#FCFAF4",
      border: "#D8D2C4",
      accent: "#4A4A4A",
      accentSoft: "#4A4A4A",
      text: "#4A4A4A",
      muted: "#4A4A4A",
    },
    fonts: {
      heading: "font-bodoni",
      body: "font-lora-regular",
      bodyBold: "font-lora-bold",
    },
  },

  works: {
    title: "Works",
    description:
      "Selection of social media content work focused on brand voice, campaign storytelling, and audience growth.",
    items: [
      {
        id: "chocosol-traders",
        url: "https://www.instagram.com/chocosoltraders/",
        imgURL: chocosolTradersImage,
        alt: "ChocoSol Traders thumbnail",
        linkLabel: "@chocosoltraders",
        minimal: true,
      },
      {
        id: "toronto-indie-author-con",
        url: "https://www.instagram.com/torontoindieauthorcon/",
        imgURL: torontoIndieAuthorConImage,
        alt: "Toronto Indie Author Con thumbnail",
        linkLabel: "@torontoindieauthorcon",
        minimal: true,
      },
      {
        id: "techfi",
        url: "https://www.instagram.com/techficorp/",
        imgURL: techfiThumbnail,
        alt: "Techfi thumbnail",
        linkLabel: "@techficorp",
        minimal: true,
      },
    ],
  },

  communications: {
    items: [
      {
        id: "case-study-01",
        title: "Digital Communication",
        image: communicationImage,
        imageAlt: "Cocoa-dusted brigadeiros and cacao nibs on a wooden board",
        imageClassName: "case-study-chocosol",
        description: "Writing for the food industry across blogs, newsletters, operations, and social media.",
        url: "",
      },
      {
        id: "case-study-02",
        title: "Digital Marketing Work",
        image: marketingImage,
        imageAlt: "Illuminated queen-of-clubs artwork in warm ivory and charcoal tones",
        description: "Blog writing for small businesses, bringing a clear voice to their digital marketing.",
        url: "",
      },
      {
        id: "case-study-03",
        title: "Long-form Articles",
        image: articlesImage,
        imageAlt: "Close-up of a printed book page with a warm ivory finish",
        description: "Weekly long-form opinion pieces for a tech startup, written for LinkedIn.",
        url: "",
      },
      {
        id: "case-study-04",
        title: "Course Content",
        image: coursesImage,
        imageAlt: "Curved balconies and repeating architectural lines beneath a softly clouded sky",
        description: "Written course content on methodologies for executives, shaped for clarity and understanding.",
        url: "",
      },
    ],
  },

  books: {
    title: "Books",
    description:
      "Published fiction and long-form storytelling, with each book available through Amazon.",
    items: [
      {
        id: "sea-of-butterflies-book",
        url: "https://www.amazon.ca/Sea-Butterflies-Bruna-Porto/dp/1804391786/",
        imgURL: seaOfButterfliesThumbnail,
        alt: "Sea of Butterflies thumbnail",
        title: "Sea of Butterflies",
        desc: "A historical fiction novel with magical elements, female resilience, and anti-war themes set during the Second World War.",
        meta: "Historical fiction",
      },
      {
        id: "entre-book",
        url: "https://www.amazon.com.br/Entre-Fogo-Gelo-1A-Edi%C3%A7%C3%A3o/dp/8537308129",
        imgURL: entreBookThumbnail,
        alt: "Entre Fogo e Gelo thumbnail",
        title: "Entre Fogo e Gelo",
        desc: "A young adult fantasy romance shaped by mythology, mystery, and forbidden love.",
        meta: "Fantasy romance",
      },
    ],
  },

  seo: {
    title: "SEO Writing",
    description: "Archive of SEO and long-form client writing.",
    items: [
      {
        id: "sre",
        url: "https://www.sommersandroth.com/blog/medical-malpractice/8-signs-of-midwife-negligence-you-should-look-out-for/",
        imgURL: sreThumbnail,
        alt: "SRE thumbnail",
        title: "Sommers Roth & Elmaleh",
        desc: "Researched and wrote SEO-focused blogs and service pages for a medical law firm.",
        subtitles: ["SEO writing", "Medical law", "Content writing"],
      },
      {
        id: "beyond-law",
        url: "https://beyond.law/practice-areas/",
        imgURL: beyondLawThumbnail,
        alt: "Beyond Law thumbnail",
        title: "Beyond Law",
        desc: "Produced targeted SEO service pages for personal injury scenarios.",
        subtitles: ["SEO writing", "Legal writing", "Copywriting"],
      },
      {
        id: "remolino_bankruptcy",
        url: "https://www.remolinoassociates.com/bankruptcy/",
        imgURL: remolinoBankruptcyThumbnail,
        alt: "Remolino Bankruptcy thumbnail",
        title: "Remolino & Associates",
        desc: "Created SEO pages about bankruptcy and consumer proposals for debt relief clients.",
        subtitles: ["SEO writing", "Financial law", "Content writing"],
      },
      {
        id: "remolino_consumer",
        url: "https://www.remolinoassociates.com/consumer-proposals/",
        imgURL: remolinoConsumerThumbnail,
        alt: "Remolino Consumer thumbnail",
        title: "Remolino & Associates",
        desc: "Wrote educational pages that supported search visibility and client trust.",
        subtitles: ["SEO writing", "Financial law", "Content writing"],
      },
      {
        id: "agile-courses",
        url: "https://agile-courses.com/scrum-product/",
        imgURL: agileCoursesThumbnail,
        alt: "Agile Courses thumbnail",
        title: "Agile Courses by VocalMeet",
        desc: "Drafted and edited learning content for professional Scrum training.",
        subtitles: ["SEO writing", "Course writing", "Editing"],
      },
    ],
  },

  writing: {
    title: "Writing",
    description:
      "Thoughts on storytelling, marketing, and building meaningful connections through words.",
    articles: [
      {
        id: "brianna-wiest-book-review",
        title: "I Read Brianna Wiest's Latest Book — And These Are My 2 Cents",
        description:
          "I first read Brianna in 2023, and became quite a late fan of the hyped and wise young writer.",
        platform: "LinkedIn",
        publishedDate: "2025-06-05",
        readTime: "5 min read",
        url: "https://www.linkedin.com/pulse/i-read-brianna-wiests-latest-book-my-2-cents-bruna-porto-7ehbc/?trackingId=SLh%2BDINlTc669z4zR6XBQQ%3D%3D",
        tags: ["Book review", "Writing", "Literature"],
      },
      {
        id: "best-books-storytelling",
        title: "The 5 Best Books for Storytelling and Plot Development",
        description: "A concise reading list for stronger storytelling and plot work.",
        platform: "LinkedIn",
        publishedDate: "2025-04-19",
        readTime: "6 min read",
        url: "https://www.linkedin.com/pulse/5-best-books-storytelling-plot-development-bruna-porto-ecp9c/?trackingId=SLh%2BDINlTc669z4zR6XBQQ%3D%3D",
        tags: ["Writing", "Storytelling", "Books"],
      },
      {
        id: "hundred-years-solitude-review",
        title: "A Hundred Years of Solitude — An Honest Review",
        description:
          "A short reflection on Marquez's classic and the mood it leaves behind.",
        platform: "LinkedIn",
        publishedDate: "2025-02-22",
        readTime: "4 min read",
        url: "https://www.linkedin.com/pulse/hundred-years-solitude-honest-review-bruna-porto-hayec/?trackingId=SLh%2BDINlTc669z4zR6XBQQ%3D%3D",
        tags: ["Book review", "Literature", "Storytelling"],
      },
    ],
  },
};

export default personalData;
